import LogoPlay from 'assets/brand/flixxo-white.svg';
import NewCreators from 'assets/brand/flixxo-primary.svg';
import Creators from 'assets/brand/creators.svg';
import {
  Container,
  LogoStyled,
  CreatorsLogo
} from './styles';

const Logo = ({
  scale=1,
  className,
  theme = 'dark',
  addCreators,
  to = '/',
}) => {


  const srcLogo = theme === 'light' ? NewCreators : LogoPlay
  
  return (
    <Container
      to={to}
      scale={scale}
      className={className}
      $marginBottom={addCreators ? -5 : 0}
    >
      <LogoStyled src={srcLogo} alt='Flixxo logo' />

      {addCreators && (
        <CreatorsLogo src={Creators} alt='Creators logo' />
      )}
    </Container>
  )
};

export default Logo;